function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "X Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.35335339,0.646546609 L6.9648,6.2581 L12.5764466,0.646546609 C12.7717088,0.451284464 13.0882912,0.451284464 13.2835534,0.646546609 C13.4788155,0.841808755 13.4788155,1.15839124 13.2835534,1.35365339 L7.6718,6.9651 L13.2833534,12.5765466 C13.4786155,12.7718088 13.4786155,13.0883912 13.2833534,13.2836534 C13.0880912,13.4789155 12.7715088,13.4789155 12.5762466,13.2836534 L6.9648,7.6721 L1.35355339,13.2836534 C1.15829124,13.4789155 0.841708755,13.4789155 0.646446609,13.2836534 C0.451184464,13.0883912 0.451184464,12.7718088 0.646446609,12.5765466 L6.2578,6.9651 L0.646246609,1.35365339 C0.450984464,1.15839124 0.450984464,0.841808755 0.646246609,0.646546609 C0.841508755,0.451284464 1.15809124,0.451284464 1.35335339,0.646546609 Z",
  id: "x-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "x-Icon/Global/x",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-Swatches/DarkGreen",
  transform: "translate(5.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "x-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#x-path-1"
})));

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x.fa324cc3.svg";
export { ForwardRef as ReactComponent };